// Categories.js
import React from 'react';

const categories = [
    "Italian",
    "American",
    "Chinese",
    "French",
    "Indian",
    "Japanese",
    "Mexican"
];

const Categories = ({ onSelectCategory }) => {
    return (
        <div className="categories-container">
            {categories.map(category => (
                <button
                    key={category}
                    onClick={() => onSelectCategory(category)}
                    className="category-button"
                >
                    {category}
                </button>
            ))}
        </div>
    );
};

export default Categories;
